; var slider = (function ($, _, window) {
    /**
    * ECHTINTERACTIE, http://wijzijnecht.nl
    * Construct the slider
    *
    * Example:  data-slider='' data-slider-config='{"duration":"4000","prevnext":true}'
    * TO-DO slider items dmv obj ipv dom creatie
    */
    var slider = function ($target, options, config) {

        /**
        * Set local variables
        */
        var config = {
            prevnext: true,
            pagination: true,
            timer: true,
            duration: 6000
        };

        this.$target = $target; //is obj
        this.$slider_wrapper = $target.children('.slider-wrapper');
        this.options = $.extend(true, config, options);
        this.timer = '' //timer variable for auto loop function
        this.items = [];

        //call _init function
        this._init();
    };

    /**
    *  init Slider function
    **/
    slider.prototype._init = function () {
        var self = this;

        self.items = this._getItems(); //get slider items

        if (self.options.prevnext)
            self._setPrevNext();

        if (self.options.pagination)
            self._setPagination();

        //load first item
        self._loadItem(self.items[0]);
    };


    /**
    *  Load new Item
    **/
    slider.prototype._loadItem = function (item) {
        var self = this,
            imgsrc = item.image,
            img = new Image();

        //clear timer
        if (self.options.timer)
            clearTimeout(self.timer);

        //set indicator
        self.$target.addClass('is--loading');

        //load new Item when image is loaded
        $(img)
            .load(function () {
                //console.log(self.items.length-1);
                var imgObj = $(this),
                    imgBox = $(item.obj).find('.slider-crop'),
                    oldItem = _.find(self.items, { 'active': true });

                imgBox.html(imgObj);

                //when active slide is--active remove active state
                if (oldItem) {
                    oldItem.active = false;
                    $(oldItem.obj).removeClass('is--active');
                }

                //remove loading class
                self.$target.removeClass('is--loading');

                //set new item active
                item.active = true;
                $(item.obj).addClass('is--active');

                self._updateNavigationControls(oldItem, item);

                //set timer function
                if (self.options.timer)
                    self._setTimer();
            })
            .error(function () {
                //indicator
            })
            .attr('width', '1900')
            .attr('height', '500')
            .attr('alt', item.alt)
            .attr('src', imgsrc);
    };


    /**
    * Set Prev and Next buttons function;
    **/
    slider.prototype._setPrevNext = function () {
        var self = this,
            btnObj = $('<a href="#next" class="btn paging next">Volgende</a><a href="#vorige" class="btn paging prev">Vorige</a>');

        if (self.items.length > 1) {
            btnObj
                .bind('click', function (e) {
                    var obj = $(this);

                    //clear timer
                    //clearInterval(self.timer);

                    if (obj.hasClass('next'))
                        self._nextItem('next');

                    if (obj.hasClass('prev'))
                        self._nextItem('prev');

                    e.preventDefault();
                })
                .appendTo(self.$target);
        }
    };


    /**
    * Go to next slide function
    * used by prev and next button and timer function
    **/
    slider.prototype._nextItem = function (pos) {
        var self = this,
            nextPos = pos == 'next' ? 1 : -1,
            activeItem = _.find(self.items, { 'active': true }),
            currentIndex = this.items.indexOf(activeItem);

        //check if last item
        if (self.items.length == currentIndex + 1 && nextPos == 1) {
            self._loadItem(self.items[0]);
            //console.log('einde')
        } else if (currentIndex == 0 && nextPos == -1) { //check if first item
            self._loadItem(self.items[self.items.length - 1]);
            //console.log('begin')
        } else {
            self._loadItem(self.items[currentIndex + nextPos]);
            //console.log('volgende')
        }
    };


    /**
    * Set pagination function
    **/
    slider.prototype._setPagination = function () {
        var self = this,
            objPaging = $('<div class="slider-pagination"><ol class="row slider-pagination-list"/></div>');

        if (self.items.length > 1) {
            for (var i in data = self.items) {
                //console.log(data);
                var html = '<li class="' + data[i].id + ' ' + data[i].title.toLowerCase() + '">';
                html += '<a href="#" data-id="' + data[i].id + '">' + data[i].title;
                //html += '<figure class="crop"><img src="'+data[i][1]+'" /></figure>';
                html += '</a></li>';

                objPaging.children().append($(html));
            }

            objPaging
                .children()
                .children()
                .children('a')
                .bind('click', function (e) {
                    var obj = $(this),
                        objIndex = obj.data('id');


                    //clearInterval(self.timer);
                    self._loadItem(_.find(self.items, { 'id': objIndex }));
                    //clear interval
                    e.preventDefault();
                });

            objPaging.appendTo(self.$target);
        }
    };


    /**
    * update update pagination and prev next buttons
    **/
    slider.prototype._updateNavigationControls = function (oldItem, item) {
        var self = this,
            currentIndex = this.items.indexOf(item);

        //update  pagination
        if (this.options.pagination) {

            if (oldItem) {
                this.$target
                    .children('.slider-pagination')
                    .find("[data-id='" + oldItem.id + "']")
                    .parent()
                    .removeClass('is--active');
            }

            this.$target
                .find("[data-id='" + item.id + "']")
                .parent()
                .addClass('is--active');
        }
    };


    /**
    * get slider items function
    **/
    slider.prototype._getItems = function () {

        var self = this,
            obj = self.$slider_wrapper.children(),
            items = [];

        obj.each(function (i) {
            var obj = $(this),
                id = 'Item-' + i,
                img = obj.find('.slider-crop').attr('data-img'),
                alt = obj.find('.slider-crop').attr('data-img-alt'),
                title = obj.find('.slider-title').text();

            obj.attr('id', id); //set id to obj (easy to find)
            items.push({ 'id': id, 'image': img, 'title': title, alt: alt, 'obj': this, 'active': false });
        });

        return items;
    };

    /**
    * Timer function
    **/
    slider.prototype._setTimer = function () {
        var self = this;


        self.timer = setTimeout(function () {
            // Do something after 5 seconds

            self._nextItem('next');
        }, self.options.duration);

    };


    /**
     * On DOM ready
     */
    $(function () {
        /**
         * Initialize wizard for all elements tagged with `[max-words]`
         */
        var initSlider = function () {

            $('[data-slider]').each(function () {
                var $target = $(this),
                    options = $target.data('slider-config');

                new slider($target, options);
            });
        };

        initSlider();
    });

})(jQuery, _, window);
